module.exports = __webpack_public_path__ + "img/025-experience.b9951323.svg";